import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import ErrorBanner from '../../components/ErrorBanner';
import { useInstallationAccess } from '../../hooks/useInstallationAccess';

export default function InstallationRouteGate({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { access, isLoading, error } = useInstallationAccess();
  if (isLoading) return <div className="settings-shell settings-page"><main className="settings-content">Checking Installation access…</main></div>;
  if (error) return <div className="settings-shell settings-page"><main className="settings-content"><ErrorBanner message="Installation access could not be verified. Refresh and try again." /></main></div>;
  if (!access.canAccess) return <Navigate to="/" replace state={{ blockedInstallationPath: location.pathname }} />;
  return <>{children}</>;
}
